export default "__VITE_ASSET__CcjN2MxM__"